"use strict";
'use clients';
exports.__esModule = true;
var react_1 = require("react");
var use_debounce_1 = require("use-debounce");
var useWindowDimensions = function () {
    var _a = (0, react_1.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    }), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        setWindowDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }, []);
    var handleResize = (0, use_debounce_1.useDebouncedCallback)(function () {
        setWindowDimensions({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }, 500);
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
};
exports["default"] = useWindowDimensions;
//# sourceMappingURL=use-window-dimensions.js.map